export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const phoneRegex = /^[+\d\s()-_]{10,15}$/;

export const numberRegex = new RegExp('^\\d+$');

export const urlPattern =
  /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;

export const environments = {
  development: 'development',
  production: 'production',
  integration: 'integration',
  preprod: 'preprod',
  e2e: 'e2e',
};

export const inviteUserStatus = {
  pending: 'pending',
  accepted: 'accepted',
  declined: 'declined',
};

export const currentEnvironment =
  process.env.REACT_APP_PUBLIC_SENTRY_ENVIRONMENT ?? '';

export const YesNoOptions = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

export const YesNoOptionsWithTrueFalse = [
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];

export const userPermissionKeys = {
  manage: 'manage',
  view: 'view',
  all: 'all',
};

export const viewPorts = {
  mobile: 360,
  tablet: 768,
  desktop: 1280,
};
